import http from '../httpService';

const PersonService = {
  getZipCodeService: zipCode => http.get(`persons/adresses/${zipCode}`),

  getPersonInArquimedesService: params => http.get('persons/arquimedes', { params }),

  getSdsDataByRgService: params => http.get('persons/sds-personal-data-by-rg', { params }),

  getSdsDataByCpfService: params => http.get('persons/sds-personal-data-by-cpf', { params }),

  updatePersonInquiry: (personId, params) => http.patch(`persons/${personId}`, params),
};

export default PersonService;
